import { useReward } from '@/contexts/reward-context';
import clsx from 'clsx';

type IconProps = {
	name?: string;
	className?: string;
};

export const Icon = ({ name, className }: IconProps) => {
	const { 
		platform, 
		imageServerDomain,
		svgBlobUrl, 
		getImageSource,
		setSvgBlobUrl
	} = useReward();

	// 開發時取消註解，避免 ui-icon.svg 吃到舊檔
	// const FILE_VERSION_ID = Math.floor(Math.random() * 1000000);
	// let path = `/events/reward/symbol/ui-icon.svg?v=${FILE_VERSION_ID}`;

	let path = '/events/reward/symbol/ui-icon.svg';

	if (getImageSource) {
		path = getImageSource(path);
	}

	if (imageServerDomain) {
		if (['Mars', 'Galaxy'].includes(platform ?? '')) {
			path = `/galaxy${path}`;
		}

		const domain = imageServerDomain.replace(/\/+$/, '');
		path = domain + path;
	}

	let url = svgBlobUrl;

	if (!url) {
		const dataURItoBlobUrl = (dataURI: string) => {
			const svg = decodeURI(dataURI);
			const blob = new Blob([svg], { type: 'image/svg+xml' });

			return URL.createObjectURL(blob);
		}

		const xmlHttp = new XMLHttpRequest();

		xmlHttp.open('GET', path, true);
		
		xmlHttp.onload = () => {
			if (xmlHttp.readyState === 4) {
				if (xmlHttp.status === 200) {
					url = dataURItoBlobUrl(xmlHttp.responseText);
					if (setSvgBlobUrl) {
						setSvgBlobUrl(url);
					}
				}
			}
		};

		xmlHttp.send(null);
	}

	return (
		<svg className={clsx(`reward-icon reward-icon--${name}`, className)}>
			<use xlinkHref={`${url}#reward-icon-${name}`}></use>
		</svg>
	)
};

export const BullhornIcon = ({ className }: IconProps) => <Icon name="bullhorn" className={className} />
export const CalendarIcon = ({ className }: IconProps) => <Icon name="calendar" className={className} />
export const CheckIcon = ({ className }: IconProps) => <Icon name="check" className={className} />
export const CloseIcon = ({ className }: IconProps) => <Icon name="close" className={className} />
export const EditorIcon = ({ className }: IconProps) => <Icon name="editor" className={className} />
export const ExclamationIcon = ({ className }: IconProps) => <Icon name="exclamation" className={className} />
export const ExpireIcon = ({ className }: IconProps) => <Icon name="expire" className={className} />
export const FireIcon = ({ className }: IconProps) => <Icon name="fire" className={className} />
export const GiftIcon = ({ className }: IconProps) => <Icon name="gift" className={className} />
export const InfoIcon = ({ className }: IconProps) => <Icon name="info" className={className} />
export const LoadingIcon = ({ className }: IconProps) => <Icon name="loading" className={className} />
export const LockIcon = ({ className }: IconProps) => <Icon name="lock" className={className} />
export const MallIcon = ({ className }: IconProps) => <Icon name="mall" className={className} />
export const NewWindowIcon = ({ className }: IconProps) => <Icon name="new-window" className={className} />
export const QestionMarkIcon = ({ className }: IconProps) => <Icon name="question-mark" className={className} />
export const RankIcon = ({ className }: IconProps) => <Icon name="rank" className={className} />
export const ShopCoinIcon = ({ className }: IconProps) => <Icon name="shop-coin" className={className} />
export const SettleCoinIcon = ({ className }: IconProps) => <Icon name="settle-coin" className={className} />
export const SbpIcon = ({ className }: IconProps) => <Icon name="sbp" className={className} />
export const SigninIcon = ({ className }: IconProps) => <Icon name="signin" className={className} />
export const SpeakerIcon = ({ className }: IconProps) => <Icon name="speaker" className={className} />
export const StoreIcon = ({ className }: IconProps) => <Icon name="store" className={className} />
export const TagIcon = ({ className }: IconProps) => <Icon name="tag" className={className} />
export const TickIcon = ({ className }: IconProps) => <Icon name="tick" className={className} />
export const TimeIcon = ({ className }: IconProps) => <Icon name="time" className={className} />
export const VipLvIcon = ({ className }: IconProps) => <Icon name="vip-lv" className={className} />
export const ArrowDownIcon = ({ className }: IconProps) => <Icon name="arrow-down" className={className} />
export const ArrowLeftIcon = ({ className }: IconProps) => <Icon name="arrow-left" className={className} />
export const ArrowRightIcon = ({ className }: IconProps) => <Icon name="arrow-right" className={className} />
export const ArrowUpIcon = ({ className }: IconProps) => <Icon name="arrow-up" className={className} />
export const BetIcon = ({ className }: IconProps) => <Icon name="bet" className={className} />
export const ChatIcon = ({ className }: IconProps) => <Icon name="chat" className={className} />
export const TaskCoinIcon = ({ className }: IconProps) => <Icon name="task-coin" className={className} />
export const DailyCheckIcon = ({ className }: IconProps) => <Icon name="daily-check" className={className} />
export const UnlockIcon = ({ className }: IconProps) => <Icon name="unlock" className={className} />
export const ParlyIcon = ({ className }: IconProps) => <Icon name="parly" className={className} />
export const PlanetIcon = ({ className }: IconProps) => <Icon name="planet" className={className} />
export const SurveyIcon = ({ className }: IconProps) => <Icon name="survey" className={className} />
export const TicketNewIcon = ({ className }: IconProps) => <Icon name="ticket-new" className={className} />
export const VoucherIcon = ({ className }: IconProps) => <Icon name="voucher" className={className} />;